import { render, staticRenderFns } from "./LandingCta.vue?vue&type=template&id=4bbe27b3&scoped=true"
import script from "./LandingCta.vue?vue&type=script&lang=js"
export * from "./LandingCta.vue?vue&type=script&lang=js"
import style0 from "./LandingCta.vue?vue&type=style&index=0&id=4bbe27b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbe27b3",
  null
  
)

export default component.exports